module.exports = __webpack_public_path__ + "img/fail.58b537db.svg";